import React from 'react';
import PropTypes from 'prop-types';
import { DataPairLayout } from '@cldf/scotiaweb-canvas-react';
import styles from './DataProducts.scss';

const DataProducts = props => {
  const titleNode = <div>{props.title}</div>;
  const childrenNode = <div>{props.text}</div>;
  const iconNode = <div>{props.icon}</div>;
  const badgeNode = <div>{props.badge}</div>;

  return (
    <DataPairLayout>
      <div>
        <div className={styles['icon--data--products']}>{iconNode}</div>
        <div className={styles['div--elements']}>
          <div>{titleNode}</div>
          <div> {childrenNode}</div>
          <div>{badgeNode}</div>
        </div>
      </div>
    </DataPairLayout>
  );
};
DataProducts.propTypes = {
  title: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.object,
    PropTypes.element
  ]).isRequired,
  text: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.object,
    PropTypes.element
  ]).isRequired
};
DataProducts.defaultProps = {
  title: '',
};

export { DataProducts };
